<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yB8mrD/tc-custom/9781426830358.jpg?1726518857037" alt="This image is the cover for the book Home to Crossroads Ranch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home to Crossroads Ranch
      </h1>
      <p class="bookDescription body article font2">
        <p>Finally, Rainy Jernagen has the child-filled home she's always wanted! Okay, so she still hasn't found Mr. Right, but the foster kids she's taken in fill her heart <i>almost</i> completely. Then handyman/rancher Nate Del Rio comes knocking, and Rainy starts to wonder if she really can have it all. There's only one problem: Nate doesn't want kids. At all. And nothing Rainy says will change his mind. Of course, she's not going to let that stop her. Not when she has a houseful of adorable allies to raid Nate's ranch and win his heartwhether he likes it or not.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Goodnight
      </h2>
      
      <p class="authorDescription body article">New York Times bestseller Linda Goodnight fell in love with words as a young child when her mother took her to a tiny library and let her fill a cardboard box with books. The next week she was back again, forever hooked on the beauty and power of the written word. Her other passions are her faith and her blended family. A former nurse and teacher, she lives in Oklahoma with her husband where she enjoys baking and travel. Connect with Linda at www.lindagoodnight.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a457e60